import styled from 'styled-components'

export const ListItemContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const OrderedList = styled.ol`
  font-size: 14px;
  padding: 0 0 0 14px;
`

export const OrderedListItem = styled.li`
  margin-bottom: 6px;
`